import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { transformCasing } from '@utils/slugs'
import EventsSlider from '@components/coach-offering-group-events/group-events-slider'
import { useNearestGroupEventsFromAddress } from '@hooks/useNearestGroupEvents'
import GroupEventSearchResultCard from '@components/group-event-search-result-card'
import Container from '@material-ui/core/Container'

const useStyles = makeStyles(theme => ({
  offeringsContainer: {
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
    },
  },
  offeringsRoot: {
    margin: '0 auto',
    paddingTop: '3rem',
    [theme.breakpoints.down('sm')]: {
      overflowX: 'hidden',
    },
  },
  offeringsOverline: {
    color: theme.palette.primary.dark,
    fontSize: '12px',
    fontFamily: 'Nunito Sans',
    letterSpacing: '1px',
  },
}))

const GroupEventsNearFacility = ({
  address,
  city,
  state,
  zip,
  facilityName,
}) => {
  const classes = useStyles()

  const nearestGroupEvents = useNearestGroupEventsFromAddress({
    address: {
      address,
      city,
      state,
      zip,
    },
  })

  if (nearestGroupEvents.length === 0) return null

  const sortedGroupEvents = nearestGroupEvents.sort((a, b) => {
    return a._rankingInfo.matchedGeoLocation.distance - b._rankingInfo.matchedGeoLocation.distance
  })

  return (
    <Container className={classes.offeringsContainer}>
      <Grid
        className={classes.offeringsRoot}
        container
        xs={12}
      >
        <Grid item xs={12}>
          <Typography
            variant="overline"
            className={classes.offeringsOverline}
          >
            Hosted near {transformCasing(facilityName)}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h4">
            Join a Class or Event
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <EventsSlider
            events={sortedGroupEvents}
            renderEvent={
              event => <GroupEventSearchResultCard event={event} location="facility" />
            }
          />
        </Grid>
      </Grid>
    </Container>
  )
}

GroupEventsNearFacility.propTypes = {
  address: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
  facilityName: PropTypes.string.isRequired,
}

export default GroupEventsNearFacility
